export const SET_SUMMARY_FILTERED_OPTIONS = 'SET_SUMMARY_FILTERED_OPTIONS';
